import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_70: DocMigration = {
  maxSchemaVersion: "0.0.70",
  description: "Ensure annotation ids are consistent",
  apply(json: any) {
    if (!json.annotation) {
      return json;
    }

    for (const annotationId in json.annotation) {
      json.annotation[annotationId].id = annotationId;
    }

    return json;
  },
};

export default migration_0_0_70;
